import { useSiteSettingsStore } from "@/store/index";

export default defineNuxtPlugin((nuxtApp) => {
  const siteSettings = useSiteSettingsStore();
  nuxtApp.provide("siteSettings", siteSettings);
});
